import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CommonService } from '../../services';
import { ManageService } from '../../services/manage.service';
import { Sort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { VendorDictionary } from '../manage-renewals-portal.component';

@Component({
  selector: 'app-manage-month',
  templateUrl: './manage-month.component.html',
  styleUrls: ['./manage-month.component.css']
})
export class ManageMonthComponent implements OnInit {
  renewalsCategories = {
    currentRenewals: 'currentRenewals',
    upcomingRenewals: 'upcomingRenewals',
    expiredRenewals: 'expiredRenewals'
  }
  months = {
      'JAN': '01',
      'FEB': '02',
      'MAR': '03',
      'APR': '04',
      'MAY': '05',
      'JUN': '06',
      'JUL': '07',
      'AUG': '08',
      'SEP': '09',
      'OCT': '10',
      'NOV': '11',
      'DEC': '12'
  };
  statusList: string[] = [
      'LOST',
      'OPEN',
      'OPTOUT',
      'WAIT',
      'WON'
  ]
  renewsList: any[] = [];
  vendorList: string[] = ['CSP', 'KASP'];
  sortedData: any;
  loadContent: boolean;
  //activeRenewals: string;
  activedRenewalIndex: number;
  selectedSerial = "";

  searchRenewals: string;
  renewalsTitle: string = '';
  renewalsStatusFilter: string[] = [];
  renewalsVendorFilter: string[] = [];

  isMiniBlade = false;
  isVendorRenwals = false;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor( private manageService: ManageService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private route: ActivatedRoute) { }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  ngOnInit() {
    this.activatedRoute.paramMap.pipe(
      switchMap((param) => { 
        this.checkUrlComponents();
        let paraMonth = param.get('month');
        let start = "", end = "";
        [start,end] = paraMonth.split("_");
        this.loadContent = false; 
        return  this.manageService.getXRenewalsList(start, end).pipe(map((res: any[]) => {
          this.renewsList = res;
          this.vendorList = Array.from(new Set(this.renewsList.map(item => item.out_vendor)));
          this.monitorVendorDictionary(this.renewsList);
          this.loadContent = true;
          }))
        }
      )).pipe(takeUntil(this.ngUnsubscribe)).subscribe();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd),takeUntil(this.ngUnsubscribe)).subscribe(() => {
        this.checkUrlComponents();
    });
    this.manageService.currentRenewlDetail.pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail:any)=>{
       const updatedRenewal = this.renewsList.find(x=>x.out_serial === detail.serial);
       if(updatedRenewal){
         updatedRenewal.out_comments = detail.comments;
         updatedRenewal.out_status = detail.status;
       }
    });
    this.manageService.renewalsTitle.subscribe({
      next: (event: string) => {
          this.renewalsTitle = event;
      }
    });
  }

  checkUrlComponents() {
    this.isMiniBlade = this.router.url.includes('renewalDetails');
    const urlCompArr = this.router.url.split("/");
    if(urlCompArr.length == 6) {
        this.selectedSerial = urlCompArr.pop();
    }
  }

  monitorVendorDictionary(list: any): void {
    let dic: VendorDictionary = {};
    list.map((val) => {
        if (!dic[val.out_vendor]) {
            dic[val.out_vendor] = val.out_vendor_image_url;
        }
    });

    this.manageService.monitorVendorDictionary(dic);

  }
  
  replaceAll(string, search, replace) {
    return string.split(search).join(replace);
  }

  onLoading(currentLoadingStatus: boolean) {
      this.loadContent = !currentLoadingStatus;
  }

  copyToClipboard(item: any): void {
      const listener = (e: ClipboardEvent) => {
          e.clipboardData.setData('text/plain', (item));
          e.preventDefault();
      };

      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);
  }

  exportRenewalsReport(): void {
      const fileName = 'Renewals';
      this.manageService.ExportRenewalsLink(fileName).subscribe((res: string) => {
          const downloadURL = window.location.origin + res;
          window.location.href = downloadURL;
      },
          (error: any) => {
              console.error(error);
              this.loadContent = true;
          });
  }

  copyRenewalsLink(): void {
      const fileName = 'Renewals';
      this.manageService.ExportRenewalsLink(fileName).subscribe((res: string) => {
          if (res) {
              const downloadURL = window.location.origin + res;
              // console.log(downloadURL);
              this.copyToClipboard(downloadURL);
              this.commonService.implementToast('Renewals download link copied to clipboard successfully', 'Success');
          }
      },
          (error: any) => {
              console.error(error);
              this.commonService.implementToast('Get Renewals download url failed', 'Error');
          });
  }

  convertMonth(date) {
      const splitDate = date.split('-');
      splitDate[1] = this.months[splitDate[1]];
      const convertedDate = splitDate.reverse().join('-');
      return convertedDate;
  }

  resetVendorFilter() {
      this.renewalsVendorFilter = [];
  }

  resetStatusFilter() {
      this.renewalsStatusFilter = [];
  }

  filterRenewals(renewals: any): boolean {

      if (this.renewalsVendorFilter.length > 0) {
          if (!this.renewalsVendorFilter.includes(renewals.out_vendor)) {
              return false;
          }
      }

      if (this.renewalsStatusFilter.length > 0) {
          if (!this.renewalsStatusFilter.includes(renewals.out_status)) {
              return false;
          }
      }

      if (this.searchRenewals) {
          if (renewals.out_end_user.toLowerCase().includes(this.searchRenewals) ||
              renewals.out_eu_reference.toLowerCase().includes(this.searchRenewals) ||
              renewals.out_expiry_date.toLowerCase().includes(this.searchRenewals) ||
              renewals.out_total_price.toLowerCase().includes(this.searchRenewals) ||
              renewals.out_message.toLowerCase().includes(this.searchRenewals)) {
              return true;
          } else {
              return false;
          }
      } else {
          return true;
      }
  }

  manageRenewals(item: any, index: number) {
      if (!this.isMiniBlade) {
          this.isMiniBlade = true;
      }
      this.activedRenewalIndex = index;
      this.router.navigate(['./renewalDetails', item.out_serial], { relativeTo: this.route });
  };

  sortData(sort: Sort) {
    const data = this.renewsList.slice();
    if (!sort.active || sort.direction === '') {
        this.sortedData = data;
        return;
    }
    this.renewsList = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'endUserName': return compare(a.out_end_user.toLowerCase(), b.out_end_user.toLowerCase(), isAsc);
          case 'nextOrderNo': return compare(a.nextOrderNo.toLowerCase(), b.nextOrderNo.toLowerCase(), isAsc);
          case 'vendor': return compare(a.out_vendor.toLowerCase(), b.out_vendor.toLowerCase(), isAsc);
          case 'invoiceDate': return compare(this.convertMonth(a.invoiceDate), this.convertMonth(b.invoiceDate), isAsc);
          case 'expiryDate': return compare(this.convertMonth(a.out_expiry_date), this.convertMonth(b.out_expiry_date), isAsc);
          case 'totalAmount': return compare(parseInt(a.out_total_price), parseInt(b.out_total_price), isAsc);
          case 'status': return compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
          default: return 0;
        }
    });
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}